import { TipSummaryComponent } from '@hb/modules/global/tip-summary/tip-summary.component';
import { ExtraInformationType } from '@hb/domain/extra-information-type';

import { Component, Input } from '@angular/core';

import { ApContentModule, ApContentService } from '@ap/content';
import { ApModalService, ModalOptions } from '@ap/modal';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApIconComponent } from '@ap/icon';
import { ApButtonComponent } from '@ap/button';

@Component({
    selector: 'extra-information',
    templateUrl: './extra-information.component.html',
    styleUrls: ['../global.scss'],
    standalone: true,
    imports: [ApContentModule, ApAnalyticsModule, ApIconComponent, ApButtonComponent]
})
export class ExtraInformationComponent {
    protected readonly types = ExtraInformationType;

    @Input() textType: ExtraInformationType = ExtraInformationType.TIP;
    @Input() tipContent: string;

    constructor(
        private readonly contentService: ApContentService,
        private readonly modalService: ApModalService
    ) {}

    openModal(): void {
        const modalOptions = new ModalOptions();
        modalOptions.title = this.contentService.get('global.tip.title-summary');
        this.modalService.open(TipSummaryComponent, modalOptions);
    }
}
